var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drawingboard"},[_vm._v(" This is the main component were you would connect things together "),_c('DrawingSpace')],1)}
var staticRenderFns = []

export { render, staticRenderFns }